<template>
  <div>

    <div style="display: flex;">

      <el-dialog title="" :visible.sync="anaInfosShow" :modal-append-to-body="false" width="60%">
        <anaInfos v-if="anaInfosShow" :anaType="anaType" :anaData="anaData"></anaInfos>
      </el-dialog>

      <div id="left-menu" class="content-son-box" style="width: 190px;margin-right: 10px;height: 100%;position: relative;top: 0px;">
        <div @click="back()"
          style="height: 30px;display: flex;align-items: center;font-weight: 600;cursor: pointer;">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
            <path
              d="M8.45728 2.66904C8.60418 2.52192 8.71467 2.35638 8.78794 2.17243C8.86161 1.9887 8.89844 1.79936 8.89844 1.60507C8.89844 1.41056 8.86161 1.21875 8.78794 1.02961C8.71428 0.840481 8.6042 0.672482 8.45728 0.525345C8.16262 0.231105 7.81085 0.0839844 7.40073 0.0839844C6.99145 0.0839844 6.63885 0.231105 6.34502 0.525345L0.497413 6.42033C0.350088 6.54656 0.24498 6.70671 0.182055 6.90122C0.118738 7.09554 0.0926619 7.29791 0.103433 7.50792C0.113354 7.71815 0.160955 7.92549 0.244964 8.13034C0.328972 8.33561 0.444426 8.51151 0.591766 8.65841L6.34502 14.4588C6.63926 14.7638 6.99145 14.9161 7.40073 14.9161C7.81087 14.9161 8.16263 14.7638 8.45728 14.4588C8.60418 14.3119 8.71467 14.1464 8.78794 13.9626C8.86161 13.7789 8.89844 13.5893 8.89844 13.3952C8.89844 13.2007 8.86161 13.0087 8.78794 12.82C8.71467 12.6309 8.6042 12.4625 8.45728 12.3151L3.69684 7.49217L8.45728 2.66904Z"
              fill="#EA3928" />
          </svg>
          <span style="margin-left: 10px;">返回</span>
        </div>
        <div style="padding: 10px 0 10px 20px;font-size: 17px;">
          <!--            <div style="margin-bottom: 10px;">目录</div>-->
          <div v-for="(item, index) in listData" :key="index">
            <div style="margin-bottom: 10px;" v-if="item.anaInfos != undefined && item.anaInfos.length > 0">
              <!-- <a style="text-decoration: none;color: #222;" :href="'#box-' + index">{{ item.labelName }}</a> -->
              <div style="cursor: pointer;color: #222;" @click="moveToId('#box-' + index)">{{ item.labelName }}</div>
            </div>
          </div>
        </div>
      </div>

      <div style="width: 1000px;">

        <div class="content-son-box" v-for="(item, index) in listData" :key="index" :id="'box-' + index">
          <div v-if="item.anaInfos != undefined && item.anaInfos.length > 0">
            <div style="display: flex;align-items: center;margin-bottom: 10px;">
              <div style="width: 3px;height: 30px;background-color: #EA3928;margin-right: 5px;"></div>
              <span style="font-size: 17px;font-weight: 700;">{{ item.labelName }}</span>
            </div>

            <div v-for="(item2, index2) in item.anaInfos" :key="index2">


              <div v-if="item2.type == 1 && item2.data.strings.length > 0" :class="item2.data.style" style="margin-bottom: 10px;">
                <div v-if="item2.data.style == 'H2'"><span style="color: #EA3928;">·</span> {{ item2.data.strings }}</div>
                <div v-else v-html="item2.data.strings.replaceAll('\n', '<br>')"></div>
              </div>

              <div v-if="item2.type == 2">
                <div style="overflow-x: auto;overflow-y: auto;max-height: 500px;" v-if="item2.data != null">
                  <table cellspacing="0" style="width: auto;min-width: 100%;">
                    <thead>
                      <tr>
                        <th v-for="(head, index3) in item2.data.head" :key="index3">{{ head }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(body, index3) in item2.data.body" :key="index3">
                        <td v-for="(bodyItem, index4) in body" :key="index4">{{ bodyItem }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="item2.type == 3">
                <div style="display: none;">{{ drawECharts('echarts-' + index + '-' + index2, item2.data) }}</div>
                <div :id="'echarts-' + index + '-' + index2" style="width: 100%;height: 300px;"></div>
              </div>

              <div v-if="item2.type == 4 || item2.type == 5">
                <div style="margin-bottom: 10px;">
                  <div style="display: flex;border: 1px solid #EA3928;width: max-content;margin: 0 auto;">
                    <!-- 初始化 -->
                    <div style="display: none;">
                      {{ selectedIndex['echarts-' + index + '-' + index2] == undefined ? $set(selectedIndex,
                        'echarts-' + index + '-' + index2, 0) : null }}
                      {{ changeChartSelect(selectedIndex['echarts-' + index + '-' + index2], 'echarts-' + index + '-' +
                        index2,
                        item2.data.chartDataList[selectedIndex['echarts-' + index + '-' + index2]], null) }}
                    </div>
                    <template v-for="(item3, index3) in item2.data.chartNameList">
                      <div :key="'s-' + index3" v-if="selectedIndex['echarts-' + index + '-' + index2] == index3"
                        class="normal-box-selected">{{ item3 }}</div>
                      <div :key="'n-' + index3" v-else class="normal-box"
                        @click="changeChartSelect(index3, 'echarts-' + index + '-' + index2, item2.data.chartDataList[index3], null)">
                        {{ item3 }}</div>
                    </template>
                  </div>
                  <div class="showInfo">
                    <div :id="'echarts-' + index + '-' + index2" style="width: 100%;height: 300px;"></div>
                  </div>
                </div>
              </div>

              <div v-if="item2.type == 10">
                <img style="width: 90%;" :src="'data:image/png;base64,' + item2.data">
              </div>

              <div v-if="item2.type == 20">

                <div v-if="item2.data.chartAnalysis[0][0].type == 24">

                  <div style="display: none">
                    {{ selectedIndex['tables-' + index + '-' + index2] == undefined ? $set(selectedIndex,
                      'tables-' + index + '-' + index2, 0) : null }}
                  </div>
                  <div style="overflow-x: auto;margin-bottom: 5px;">
                    <div :style="{ height: '36px', width: 120 * item2.data.chartAnalysis.length + 'px' }"
                      v-if="item2.data.chartAnalysis.length > 1">
                      <div style="display: inline-block;margin-right: 10px;"
                        v-for="(item3, index3) in item2.data.chartNames" :key="index3">
                        <div style="width: 90px;" v-if="selectedIndex['tables-' + index + '-' + index2] == index3"
                          class="normal-button-selected">{{ item3 }}</div>
                        <div style="width: 90px;" v-else class="normal-button"
                          @click="changeChartSelect(index3, 'tables-' + index + '-' + index2)">{{ item3 }}</div>
                      </div>
                    </div>
                  </div>
                  <div style="overflow-x: auto;overflow-y: auto;max-height: 500px;"
                    v-if="item2.data.chartAnalysis != null">
                    <table cellspacing="0" style="width: auto;min-width: 100%;">
                      <thead>
                        <tr>
                          <th style="min-width: 100px;"
                            v-for="(head, index3) in item2.data.chartAnalysis[selectedIndex['tables-' + index + '-' + index2]][0].data.head"
                            :key="index3">{{ head }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(body, index3) in item2.data.chartAnalysis[selectedIndex['tables-' + index + '-' + index2]][0].data.body"
                          :key="index3">
                          <td v-for="(bodyItem, index4) in body" :key="index4">{{ bodyItem }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
                <div v-else>
                  <div v-for="(item3, index3) in item2.data.chartAnalysis" :key="index3">
                    <div v-for="(item4, index4) in item3" :key="index4">

                      <div v-if="item4.type == 1" :class="item4.data.style" style="margin-bottom: 10px;">
                        <div v-if="item4.data.style == 'H2'"><span style="color: #EA3928;">·</span> {{ item4.data.strings }}</div>
                        <div v-else v-html="item4.data.strings.replaceAll('\n', '<br>')"></div>
                      </div>

                      <div v-if="item4.type == 4">
                        <div style="margin-bottom: 10px;">
                          <div style="display: flex;border: 1px solid #EA3928;width: max-content;margin: 0 auto;">
                            <!-- 初始化 -->
                            <div style="display: none;">
                              {{ selectedIndex['echarts-' + index + '-' + index2 + '-' + index3 + '-' + index4] ==
                                undefined
                                ?
                                $set(selectedIndex, 'echarts-' + index + '-' + index2 + '-' + index3 + '-' + index4, 0) :
                                null
                              }}
                              {{ changeChartSelect(selectedIndex['echarts-' + index + '-' + index2 + '-' + index3 + '-' +
                                index4],
                                'echarts-' + index + '-' + index2 + '-' + index3 + '-' + index4,
                                item4.data.chartDataList[selectedIndex['echarts-' + index + '-' + index2 + '-' + index3 +
                                '-'
                                + index4]],
                                item4.data.tableList[selectedIndex['echarts-' + index + '-' + index2 + '-' + index3 + '-' +
                                index4]]) }}
                            </div>
                            <template v-for="(item5, index5) in item4.data.chartNameList">
                              <div :key="'s-' + index5"
                                v-if="selectedIndex['echarts-' + index + '-' + index2 + '-' + index3 + '-' + index4] == index5"
                                class="normal-box-selected">{{ item5 }}</div>
                              <div :key="'n-' + index5" v-else class="normal-box"
                                @click="changeChartSelect(index5, 'echarts-' + index + '-' + index2 + '-' + index3 + '-' + index4, item4.data.chartDataList[index5], item4.data.tableList[index5])">
                                {{ item5 }}</div>
                            </template>
                          </div>
                          <div class="showInfo">
                            <div :id="'echarts-' + index + '-' + index2 + '-' + index3 + '-' + index4"
                              style="width: 100%;height: 300px;">
                            </div>
                          </div>
                          <div style="overflow-x: auto;overflow-y: auto;max-height: 500px;">
                            <table cellspacing="0" style="width: auto;min-width: 100%;">
                              <thead>
                                <tr>
                                  <th
                                    v-for="(head, index5) in chartTableData['echarts-' + index + '-' + index2 + '-' + index3 + '-' + index4].head"
                                    :key="index5">{{ head }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(body, index5) in chartTableData['echarts-' + index + '-' + index2 + '-' + index3 + '-' + index4].body"
                                  :key="index5">
                                  <td v-for="(bodyItem, index6) in body" :key="index6">{{ bodyItem }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div v-if="item4.type == 21">
                        <div v-for="(item5, index5) in item4.data" :key="index5"
                          style="display: flex;margin-bottom: 10px;padding-bottom: 10px;border-bottom: 1px solid #dedede;">
                          <div style="width: 150px;color: #333;">
                            {{ item5.firstColumnValue }}
                          </div>
                          <div style="flex: 1;">
                            {{ item5.seconColumnValue }}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div v-if="item2.type == 22">
                <div style="overflow-x: auto;overflow-y: auto;max-height: 530px;" v-if="item2.data != null">
                  <table cellspacing="0" style="width: auto;min-width: 100%;">
                    <thead>
                      <tr>
                        <th style="min-width: 100px;" v-for="(head, index3) in tableData22(item2.data, 'head')"
                          :key="index3">{{ head }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(body, index3) in tableData22(item2.data, 'body')" :key="index3">
                        <td v-for="(bodyItem, index4) in body" :key="index4">{{ bodyItem }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="item2.type == 231">
                <div style="overflow-x: auto;overflow-y: auto;max-height: 500px;" v-if="item2.data != null">
                  <table cellspacing="0" style="width: auto;min-width: 100%;">
                    <thead>
                      <tr>
                        <th style="min-width: 100px;">高管姓名</th>
                        <th style="min-width: 100px;">职位</th>
                        <th style="min-width: 100px;">学历</th>
                        <th style="min-width: 100px;">年龄</th>
                        <th style="min-width: 100px;">性别</th>
                        <th style="min-width: 100px;">年薪</th>
                        <th style="min-width: 100px;">持股数量</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item3, index3) in item2.data.projectMsgList" :key="index3">
                        <td>{{ item3.entryName }}</td>
                        <td>{{ item2.data.projectBodies[index3].position }}</td>
                        <td>{{ item2.data.projectBodies[index3].highDegree }}</td>
                        <td>{{ item2.data.projectBodies[index3].age }}</td>
                        <td>{{ item2.data.projectBodies[index3].sex }}</td>
                        <td>{{ item2.data.projectBodies[index3].salary }}</td>
                        <td>{{ item2.data.projectBodies[index3].holdNum }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="item2.type == 233">
                <div style="overflow-x: auto;overflow-y: auto;max-height: 500px;" v-if="item2.data != null">
                  <table cellspacing="0" style="width: auto;min-width: 100%;">
                    <thead>
                      <tr>
                        <th style="min-width: 100px;">变动人</th>
                        <th style="min-width: 100px;">董监高管</th>
                        <th style="min-width: 100px;">高管职位</th>
                        <th style="min-width: 100px;">与高管关系</th>
                        <th style="min-width: 100px;">日期</th>
                        <th style="min-width: 100px;">变动数量(股)</th>
                        <th style="min-width: 100px;">交易均价(元)</th>
                        <th style="min-width: 100px;">结存股票(股)</th>
                        <th style="min-width: 100px;">交易方式</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item3, index3) in item2.data.projectMsgList" :key="index3">
                        <td>{{ item3.entryName }}</td>
                        <td>{{ item2.data.projectBodies[index3].executiveName }}</td>
                        <td>{{ item2.data.projectBodies[index3].position }}</td>
                        <td>{{ item2.data.projectBodies[index3].executiveRelation }}</td>
                        <td>{{ item2.data.projectBodies[index3].endDate }}</td>
                        <td>{{ item2.data.projectBodies[index3].changeNum }}</td>
                        <td>{{ item2.data.projectBodies[index3].averagePrice }}</td>
                        <td>{{ item2.data.projectBodies[index3].changeAfterHoldnum }}</td>
                        <td>{{ item2.data.projectBodies[index3].tradeWay }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="item2.type == 25">
                <div style="max-height: 500px;overflow-y: auto;">

                  <div style="display: flex;align-items: center;" v-for="(item3, index3) in item2.data" :key="index3">
                    <div style="width: 100px;color: #595959;">
                      {{ item3.year + '-' + item3.date }}
                    </div>
                    <div style="width: 1px;height: 70px;background-color: #EA3928;margin: 10px 30px;"></div>
                    <div style="flex: 1;">
                      <div>
                        <span style="font-size: 20px;line-height: 30px;">{{ item3.comEvent.eventType }}</span>
                        <span style="font-size: 14px;color: #666;cursor: pointer;"
                          v-if="item3.type == 2 || item3.type == 3" @click="viewSimilarInfos(item3.comEvents)">同类事件</span>
                      </div>
                      <div>
                        <span style="font-size: 16px;">{{ item3.comEvent.l1Content }}</span>
                        <span style="font-size: 14px;color: #666;cursor: pointer;"
                          v-if="item3.type == 1 || item3.type == 3"
                          @click="viewExpandInfos(item3.comEvent.detailEvents)">展开</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>
    
<script>
import * as echarts from "echarts";
import { linkName, sendRequestIndustry } from '../../../../static/js/util';
import anaInfos from '../business/anaInfos.vue';

export default {
  components: {
    anaInfos
  },
  data() {
    return {
      comCode: '',
      name: '',

      titleList: [],

      selectedIndex: {},
      listData: [],
      chartTableData: {},

      anaInfosShow: false,
      anaType: 0,
      anaData: null,
    };
  },
  mounted() {
    this.comCode = this.$route.query.comCode;
    this.name = this.$route.query.comName;

    window.parent.onscroll = () => {
      var scrollHeight = window.parent.scrollY;
      if (scrollHeight > 100) {
        $('#left-menu').css({ top: scrollHeight - 100 + 'px' });
      } else {
        $('#left-menu').css({ top: '0px' });
      }
    }

    this.getData();
  },
  methods: {
    back() {
      linkName(this, 'companyResearch');
    },
    moveToId(idStr) {
      document.querySelector(idStr).scrollIntoView({
        behavior: "smooth"
     });
    },
    getData() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });

      let url = '/company/gsjkResult/' + this.comCode;
      sendRequestIndustry(url, 'get', null, response => {
        loading.close();
        if (response.data.code === 0) {
          this.listData = response.data.data.data.horizontalLabels;

          //去掉空的项
          for (var i = 0; i < this.listData.length; i++) {
            if (this.listData[i] == null || this.listData[i].length < 1) {
              this.listData.splice(i, 1);
              i--;
            }
            // if(this.listData[i].showInfos[0].data.chartAnalysis[])
          }



        } else if (response.data.code === 1) {

        }
      }, error => {
        loading.close();
        console.log(error);
      })
    },
    changeChartSelect(sign, idStr, echartsData, tableData) {
      // this.selectedIndex[idStr] = sign;//页面不刷新
      // Vue.set(this.selectedIndex, idStr, sign);//动态添加能刷新
      this.$set(this.selectedIndex, idStr, sign);//动态添加能刷新

      if (echartsData != undefined && echartsData != null) {
        //清除echarts图
        // $('.showInfo div[_echarts_instance_]').html("");
        // $('.showInfo div[_echarts_instance_]').removeAttr("_echarts_instance_");

        // var temp = echarts.init(document.getElementById(idStr));
        // if(temp!=null || temp!=undefined){
          // temp.dispose();
        // }
        
        // var dom = $('#' + idStr);
        // dom.html("");
        // dom.removeAttr("_echarts_instance_");
        

        this.drawECharts(idStr, echartsData);
      }
      // this.chartTableData[idStr] = tableData;
      // Vue.set(this.chartTableData, idStr, tableData);
      if (tableData != undefined && tableData != null) {
        this.$set(this.chartTableData, idStr, tableData);
      }

    },
    //画echarts图
    drawECharts(idName, data) {
      setTimeout(() => {
        // console.log(idName)
        var chartDom = document.getElementById(idName);
        var myChart = echarts.init(chartDom);
        var option = JSON.parse(data);
        option && myChart.setOption(option);
      }, 300)
    },
    //处理type=22的表格
    tableData22(data, sign) {
      var res = [];
      if (sign == 'head') {
        res.push('公告日期');
        for (var i = 0; i < data.slidingTableDates.length; i++) {
          res.push(data.slidingTableDates[i].dateValue);
        }
        return res;
      } else if (sign == 'body') {
        for (var i = 0; i < data.slidingTableSubjectNames.length; i++) {
          var row = [];
          row.push(data.slidingTableSubjectNames[i].subjectName);
          for (var j = 0; j < data.slidingTableInfos.length; j++) {
            row.push(data.slidingTableInfos[j].valueInfoEleList[i].subjectVal)
          }
          res.push(row);
        }
        return res;
      }

    },
    viewSimilarInfos(data) {
      var dataTemp = [];
      for (var i = 0; i < data.length; i++) {
        var row1 = {
          data: {
            style: 'H3',
            strings: data[i].eventType + '    ' + data[i].noticeDate
          },
          type: 1
        }
        var row2 = {
          data: {
            style: 'T',
            strings: data[i].l1Content
          },
          type: 1
        }
        dataTemp.push(row1);
        dataTemp.push(row2);
      }

      // window.parent.researchVue.viewAnaInfos(dataTemp);
      this.anaType = 1;
      this.anaData = dataTemp;
      this.anaInfosShow = true;
    },
    viewExpandInfos(data) {
      var dataTemp = [];
      for (var i = 0; i < data.length; i++) {
        var row = {
          data: {
            style: 'T',
            strings: data[i].contentData
          },
          type: 1
        }
        dataTemp.push(row);
      }

      // window.parent.researchVue.viewAnaInfos(dataTemp);
      this.anaType = 1;
      this.anaData = dataTemp;
      this.anaInfosShow = true;
    }
  }
};
</script>
    
<style scoped>
.H2 {
  /*display: none;*/
  font-size: 16px;
  font-weight: 700;
  padding: 6px 0;
  margin: 10px 0;
  /* background-color: #e6e6e6; */
}

.T1 {
  color: #666;
}


.normal-button {
  background-color: #F0F2F4;
  color: #000;
  padding: 7px 10px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.normal-button-selected {
  background-color: #f6e2e3;
  color: #EA3928;
  padding: 7px 10px;
  border-radius: 5px;
  font-size: 16px;
}

.normal-box {
  background-color: #fff;
  color: #999;
  padding: 4px 20px;
  cursor: pointer;
}

.normal-box-selected {
  background-color: #EA3928;
  color: #fff;
  padding: 4px 20px;
}

table {
  width: 100%;
  text-align: center;
  border-top: 1px solid #f2887e;
  border-left: 1px solid #f2887e;
}

th,
td {
  line-height: 30px;
}

/* th {
  background-color: #e6e6e6;
} */

th,td {
  border-bottom: 1px solid #f2887e;
  border-right: 1px solid #f2887e;
}

.content-son-box {
  margin-top: 30px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}
</style>